import React from 'react';
import * as Icon from 'react-feather';
import { all_routes } from 'core/data/routes/all_routes';
const routes = all_routes;

export const menuConfig = [
    {
        tittle: 'Contenido Web',
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: 'Pagina Principal',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.homeItemsAdmin,
                icon: <Icon.Home className="react-feather-icon" />,
            },
            {
                menuValue: 'Banner Principal',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.homeBannerSlider,
                icon: <Icon.Image className="react-feather-icon" />,
            },
            {
                menuValue: 'Acerca de Artectum',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.aboutArtectum,
                icon: <Icon.BookOpen className="react-feather-icon" />,
            },
            {
                menuValue: 'FAQ',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.faqadmin,
                icon: <Icon.HelpCircle className="react-feather-icon" />,
            },
            {
                menuValue: 'Blogs',
                hasSubRoute: true,
                showSubRoute: true,
                route: routes.blogAdmin,
                icon: <Icon.FileText className="react-feather-icon" />,
                subMenus: [
                    {
                        menuValue: 'Blog',
                        route: routes.blogAdmin,
                    },
                    {
                        menuValue: 'Comentarios del Blog',
                        route: routes.blogCommentsAdmin,
                    },
                    {
                        menuValue: 'Carrusel de Blog',
                        route: routes.blogSlideSectionAdmin,
                    }
                ]
            }
        ],
    },
    {
        tittle: 'ADMINISTRACIÓN',
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: 'Proyectos',
                hasSubRoute: true,
                showSubRoute: true,
                route: routes.projects,
                icon: <Icon.Folder className="react-feather-icon" />,
                subMenus: [
                    {
                        menuValue: 'Proyectos',
                        route: routes.projectsAdmin,
                    },
                    {
                        menuValue: 'Detalles del Proyecto',
                        route: routes.projectDetailsAdmin,
                    }
                ]
            },
            {
                menuValue: 'Productos',
                hasSubRoute: true,
                showSubRoute: true,
                route: routes.productAdmin,
                icon: <Icon.Package className="react-feather-icon" />,
                subMenus: [
                    {
                        menuValue: 'Producto',
                        route: routes.productAdmin,
                    },
                    {
                        menuValue: 'Variantes de Producto',
                        route: routes.productOptionsAdmin,
                    },
                    {
                        menuValue: 'Especificaciones de Producto',
                        route: routes.productSpecificationAdmin,
                    }
                ]
            },
            {
                menuValue: 'Filtros',
                hasSubRoute: true,
                showSubRoute: true,
                route: routes.filtersAdmin,
                icon: <Icon.Filter className="react-feather-icon" />,
                subMenus: [
                    {
                        menuValue: 'Filtros',
                        route: routes.filtersAdmin,
                    },
                    {
                        menuValue: 'Filtos de Producto',
                        route: routes.productFiltersAdmin,
                    },
                    {
                        menuValue: 'Filtos de Proyecto',
                        route: routes.projectFiltersAdmin,
                    }
                ]
            },
            {
                menuValue: 'Videos de Ayuda',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.productHelp,
                icon: <Icon.HelpCircle className="react-feather-icon" />,
            },
            {
                menuValue: 'Categorias',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.categoriesAdmin,
                icon: <Icon.Command className="react-feather-icon" />,
            },
            {
                menuValue: 'Clientes',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.clientsAdmin,
                icon: <Icon.Check className="react-feather-icon" />,
            },
            {
                menuValue: 'Información',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.informationAdmin,
                icon: <Icon.Info className="react-feather-icon" />,
            }
        ],
    },
    {
        tittle: 'Reportes',
        showAsTab: false,
        separateRoute: false,
        menu: [
            {
                menuValue: 'Usuarios Registrados',
                hasSubRoute: false,
                showSubRoute: false,
                route: routes.contactFormAdmin,
                icon: <Icon.UserCheck className="react-feather-icon" />,
            },
        ],
    },
];